import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable */
import React from "react";
import MaskedInput from "react-text-mask";
import { useStateStrict } from "@ajayvikas/react-common";
import { createNumberMask } from "./createNumberMask";
export const NumericInput = React.forwardRef((props, forwardRef) => {
    const { value, onChange: propsOnChange, onBlur: propsOnBlur, onFocus: propsOnFocus, className, defaultValue, __fireOnChangeOnUnmount, showMask, onKeyDown, ...restWithNumericProps } = props;
    const { prefix = "", //dollarSign,
    suffix = "", includeThousandsSeparator = false, //true
    thousandsSeparatorSymbol = ",", allowDecimal = false, decimalSymbol = ".", decimalLimit = 2, allowNegative = false, allowLeadingZeroes = false, integerLimit = undefined, ...rest } = restWithNumericProps;
    const [stateValue, setStateValue] = useStateStrict(value === undefined || value === null ? "" : value.toString());
    const [initValue, setInitValue] = useStateStrict(value === undefined || value === null ? "" : value.toString());
    React.useEffect(() => {
        setStateValue(value === undefined || value === null ? "" : value.toString());
        setInitValue(value === undefined || value === null ? "" : value.toString());
    }, [setStateValue, value]);
    const numberMask = React.useMemo(() => {
        return createNumberMask(prefix, suffix, includeThousandsSeparator, thousandsSeparatorSymbol, allowDecimal, decimalSymbol, decimalLimit, allowNegative, allowLeadingZeroes, integerLimit);
    }, [prefix, suffix, includeThousandsSeparator, thousandsSeparatorSymbol, allowDecimal,
        decimalSymbol, decimalLimit, allowNegative, allowLeadingZeroes, integerLimit]);
    const onInput = (e) => {
        const inputValue = e.target.value;
        setStateValue(inputValue);
    };
    const onChange = (e) => {
        if (initValue === stateValue)
            return;
        if (stateValue === "")
            return propsOnChange?.(undefined);
        const numericValue = +stateValue;
        if (isNaN(numericValue)) {
            debugger;
            throw new Error("");
        }
        propsOnChange?.(numericValue);
    };
    const onBlur = (e) => {
        onChange(e);
        propsOnBlur?.(e);
    };
    const setRef = React.useCallback((ref) => {
        if (forwardRef) {
            if (typeof forwardRef === "function") {
                forwardRef(ref?.inputElement);
            }
            else {
                forwardRef.current = ref?.inputElement;
            }
        }
    }, []);
    const onInputKeyDown = (e) => {
        onKeyDown?.(e);
        if (e.defaultPrevented) {
            onChange();
        }
    };
    return _jsx(MaskedInput, { ref: setRef, ...rest, className: className, mask: numberMask, guide: false, showMask: true, value: stateValue, onChange: onInput, onKeyDown: __fireOnChangeOnUnmount ? onInputKeyDown : onInputKeyDown, onBlur: onBlur });
});
